import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { HttpConfigInterceptor } from './interceptors/httpconfig.interceptor';
import {  HTTP_INTERCEPTORS } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './pages/home/home.component';
import { WelcomeBannerComponent } from './pages/home/components/welcome-banner/welcome-banner.component';
import { HowIChooseComponent } from './pages/home/components/how-i-choose/how-i-choose.component';
import { FindYourMidwifeComponent } from './pages/home/components/find-your-midwife/find-your-midwife.component';
import { BlogsComponent } from './pages/home/components/blogs/blogs.component';
import { NewsLetterComponent } from './pages/home/components/news-letter/news-letter.component';
import { HeaderComponent } from './pages/shared-components/header/header.component';
import { FooterComponent } from './pages/shared-components/footer/footer.component';
import { SearchListingComponent } from './pages/search-listing/search-listing.component';
import { SearchFiltersComponent } from './pages/search-listing/components/search-filters/search-filters.component';
import { ProfileListComponent } from './pages/search-listing/components/profile-list/profile-list.component';
import { ProfileCardComponent } from './pages/shared-components/profile-card/profile-card.component';
import { ProfileComponent } from './pages/profile/profile.component';
import { ProfileDetailComponent } from './pages/profile/components/profile-detail/profile-detail.component';
import { MyRecentBlogsComponent } from './pages/profile/components/my-recent-blogs/my-recent-blogs.component';
import { BookAnAppointmentComponent } from './pages/profile/components/book-an-appointment/book-an-appointment.component';
import { ReviewsAndRatingsComponent } from './pages/profile/components/reviews-and-ratings/reviews-and-ratings.component';
import { PeopleReviewsComponent } from './pages/profile/components/people-reviews/people-reviews.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { ProfileInfoComponent } from './pages/dashboard/components/common/profile-info/profile-info.component';
import { ChatsComponent } from './pages/dashboard/components/common/chats/chats.component';
import { YourPregnancyComponent } from './pages/dashboard/components/dashboard-mom/your-pregnancy/your-pregnancy.component';
import { BookedMidwifesComponent } from './pages/dashboard/components/dashboard-mom/booked-midwifes/booked-midwifes.component';
import { BlogsAndArticlesComponent } from './pages/dashboard/components/dashboard-mom/blogs-and-articles/blogs-and-articles.component';
import { TipsForPregnancyComponent } from './pages/dashboard/components/dashboard-mom/tips-for-pregnancy/tips-for-pregnancy.component';
import { MyCalendarComponent } from './pages/dashboard/components/dashboard-midwife/my-calendar/my-calendar.component';
import { MyBlogsComponent } from './pages/dashboard/components/dashboard-midwife/my-blogs/my-blogs.component';
import { AppointmentRequestsComponent } from './pages/dashboard/components/dashboard-midwife/appointment-requests/appointment-requests.component';
import { NotificationsComponent } from './pages/dashboard/components/dashboard-midwife/notifications/notifications.component';
import { SignedUpClientsComponent } from './pages/dashboard/components/dashboard-midwife/signed-up-clients/signed-up-clients.component';
import { ChatMainComponent } from './pages/chat-main/chat-main.component';
import { ChatListComponent } from './pages/chat-main/components/chat-list/chat-list.component';
import { ChatMessagesComponent } from './pages/chat-main/components/chat-messages/chat-messages.component';
import { UserAuthComponent } from './pages/user-auth/user-auth.component';
import { LoginComponent } from './pages/user-auth/components/login/login.component';
import { SignUpComponent } from './pages/user-auth/components/sign-up/sign-up.component';
import { MapLocationComponent } from './pages/shared-components/map-location/map-location.component';
import { ForgotPasswordComponent } from './pages/user-auth/components/forgot-password/forgot-password.component';
import { MatNativeDateModule } from '@angular/material/core';
import { OtpInputComponent } from './pages/shared-components/otp-input/otp-input.component';
import { EditProfileComponent } from './pages/edit-profile/edit-profile.component';
import { ImageCropperModule } from 'ngx-image-cropper';
import { ImageUploadComponent } from './pages/shared-components/image-upload/image-upload.component';
import { MyNotesComponent } from './pages/dashboard/components/dashboard-midwife/my-notes/my-notes.component';
import { NoteListingComponent } from './pages/note-listing/note-listing.component';
import { AuthService } from './services/auth.service';

import { MatChipsModule } from '@angular/material/chips';
import {MatFormFieldModule} from '@angular/material/form-field';
import { NoopAnimationsModule } from '@angular/platform-browser/animations';
import {MatInputModule} from '@angular/material/input';
import {MatIconModule} from '@angular/material/icon';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatMenuModule} from '@angular/material/menu';
import {MatButtonModule} from '@angular/material/button';
import {MatSelectModule} from '@angular/material/select';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import { NgCircleProgressModule } from 'ng-circle-progress';
import { WriteTestimonialComponent } from '../app/pages/shared-components/write-testimonial/write-testimonial.component';
import { RateMidwifeComponent } from '../app/pages/shared-components/rate-midwife/rate-midwife.component';
import { WriteIntroComponent } from './pages/shared-components/write-intro/write-intro.component';
import { AppointmentModalComponent } from './pages/shared-components/appointment-modal/appointment-modal.component';
import { CreateNoteComponent } from './pages/shared-components/create-note/create-note.component';
import { TimeagoModule } from 'ngx-timeago';
import { BlogListingComponent } from './pages/blog-listing/blog-listing.component';
import { BlogDetailComponent } from './pages/blog-detail/blog-detail.component';
import { CreateBlogComponent } from './pages/create-blog/create-blog.component';
import { ReactiveFormsModule } from '@angular/forms';
import { WebcamModule } from 'ngx-webcam';
import { NotificationMomComponent } from './pages/dashboard/components/dashboard-mom/notification-mom/notification-mom.component';
import { GenericCalendarComponent } from './pages/shared-components/generic-calendar/generic-calendar.component';
import { EditProfileMumComponent } from './pages/edit-profile-mum/edit-profile-mum.component';
import {DatePipe} from '@angular/common';
import { BookingModalComponent } from './pages/shared-components/booking-modal/booking-modal.component';
import { DueDateCalcComponent } from './pages/shared-components/due-date-calc/due-date-calc.component';
import { RatingListingComponent } from './pages/rating-listing/rating-listing.component';
import { environment } from 'src/environments/environment';
import { AngularFireModule } from '@angular/fire/compat';
import { AngularFireStorageModule } from '@angular/fire/compat/storage';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { ViewBookingComponent } from './pages/shared-components/view-booking/view-booking.component';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    WelcomeBannerComponent,
    HowIChooseComponent,
    FindYourMidwifeComponent,
    BlogsComponent,
    NewsLetterComponent,
    HeaderComponent,
    FooterComponent,
    SearchListingComponent,
    SearchFiltersComponent,
    ProfileListComponent,
    ProfileCardComponent,
    ProfileComponent,
    ProfileDetailComponent,
    MyRecentBlogsComponent,
    BookAnAppointmentComponent,
    ReviewsAndRatingsComponent,
    PeopleReviewsComponent,
    DashboardComponent,
    ProfileInfoComponent,
    ChatsComponent,
    YourPregnancyComponent,
    BookedMidwifesComponent,
    BlogsAndArticlesComponent,
    TipsForPregnancyComponent,
    MyCalendarComponent,
    MyBlogsComponent,
    AppointmentRequestsComponent,
    NotificationsComponent,
    SignedUpClientsComponent,
    ChatMainComponent,
    ChatListComponent,
    ChatMessagesComponent,
    UserAuthComponent,
    LoginComponent,
    SignUpComponent,
    MapLocationComponent,
    ForgotPasswordComponent,
    OtpInputComponent,
    EditProfileComponent,
    ImageUploadComponent,
    MyNotesComponent,
    NoteListingComponent,
    WriteTestimonialComponent,
    RateMidwifeComponent,
    WriteIntroComponent,
    AppointmentModalComponent,
    CreateNoteComponent,
    BlogListingComponent,
    BlogDetailComponent,
    CreateBlogComponent,
    NotificationMomComponent,
    GenericCalendarComponent,
    EditProfileMumComponent,
    BookingModalComponent,
    DueDateCalcComponent,
    RatingListingComponent,
    ViewBookingComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    BrowserAnimationsModule,
    MatChipsModule,
    NoopAnimationsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatAutocompleteModule,
    MatDatepickerModule,
    MatNativeDateModule,
    ImageCropperModule,
    MatMenuModule,
    MatButtonModule,
    MatSelectModule,
    MatSnackBarModule,
    ImageCropperModule,
    ReactiveFormsModule,
    WebcamModule,
    InfiniteScrollModule,
    NgCircleProgressModule.forRoot({
      "backgroundPadding": -2,
      "radius": 70,
      "space": -8,
      "toFixed": 0,
      "maxPercent": 100,
      "outerStrokeGradient": true,
      "outerStrokeWidth": 8,
      "outerStrokeColor": "#686EC0",
      "outerStrokeGradientStopColor": "#686EC0",
      "innerStrokeColor": "#e7e8ea",
      "innerStrokeWidth": 8,
      "imageHeight": 80,
      "imageWidth": 80,
      "animationDuration": 700,
      "showSubtitle": false,
      "showUnits": false,
      "showBackground": true,
      "titleFontSize": '20',
      "lazy": false}),
    TimeagoModule.forRoot(),
    AngularFireModule.initializeApp(environment.firebaseConfig),
    AngularFireStorageModule
  ],
  providers: [
    AuthService,
    DatePipe,
    { provide: HTTP_INTERCEPTORS, useClass: HttpConfigInterceptor, multi: true }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
